import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('vehicleDomains', {
  customKeys: {
    list: 'domains',
  },
  customEndpoints: {
    list: '/ui/vehicle_models/form',
  },
});
